import { Chart } from 'chart.js/auto';

(window as any).Chart = Chart;
